import { take, isEmpty, compose, map, entries } from 'lodash/fp';
import { DashboardPie } from '../DashboardPie';
import { PieChartData } from '../types';
import {
    ValueElement,
    ValueWrapperElement,
    PieElement,
    LabelsWrapperElement,
    ChartElement,
    LabelElement,
    LabelCircle,
} from './styles';
import { MAX_VALUE_ELEMENTS } from './constants';

const mapValues = compose(
    map(([index, data]) => (
        <ValueElement key={index} color={data.color}>
            {data.valueLabel || data.value}
        </ValueElement>
    )),
    entries,
    take(MAX_VALUE_ELEMENTS)
);

const mapLabels = compose(
    map(([index, data]) => (
        <LabelElement key={index} color={data.color}>
            <LabelCircle color={data.color} />
            {data.label}
        </LabelElement>
    )),
    entries
);

export const PieChart = ({ data = [] }: { data: PieChartData[] }) => {
    if (isEmpty(data)) {
        return null;
    }

    return (
        <ChartElement>
            <PieElement>
                <DashboardPie data={data} />
                <ValueWrapperElement>{mapValues(data)}</ValueWrapperElement>
            </PieElement>
            <LabelsWrapperElement>{mapLabels(data)}</LabelsWrapperElement>
        </ChartElement>
    );
};
